<div [ngStyle]="{ 'width': dropdownWidth }">
  <pp-hide-dropdown (ppHideDropdown)="hideDropdown()"></pp-hide-dropdown>

  <ul class="dropdownWrapper">
    @for (item of items; track item) {
      <li (click)="selectItem(item)" class="dropdownItem">
        <tr class="multipleSelect__row">
          <pp-toggle
            [ppId]="'multipleSelectToggle' + item.value"
            [ppChecked]="item.selected"
            ppStyle="filter"
            (ppAction)="selectItem(item)"
          ></pp-toggle>
          @if (item.iconSrc) {
            <pp-icon [ppDisplayContents]="true" [ppClass]="iconClass" ppColor="grey-500" [ppSrc]="item.iconSrc" />
          }
          {{
          item.label
          }}
        </tr>
      </li>
    }
  </ul>
</div>
